var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{staticClass:"white--text",class:{'animated' : _vm.animated},attrs:{"justify-center":"","align-center":"","dd-dark":"","lighten-1":"","px-5":"","py-5":"","fadeIn":"","delay-1s":""}},[_vm._t("content")],2)}
var staticRenderFns = []

export { render, staticRenderFns }